exports = module.exports = require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\cssToString.js")();
require("C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\mergeImport.js")(exports, require("-!C:\\Users\\kop\\Repos\\webpack\\node_modules\\css-loader\\index.js!./folder/stylesheet-import1.css"), "");
exports.push([module.id, "\r\n\r\n.rule-direct {\r\n\tbackground: lightgreen;\r\n}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/css-loader!./loaders/_css/stylesheet.css
 ** module id = 1
 ** module chunks = 0
 **/